import { combineReducers } from '@reduxjs/toolkit';
import authReducer from "../admin/reducers/authReducer"
import contentReducer from "../admin/reducers/contentReducer"
import projectReducer from "../admin/reducers/projectReducer"
const adminReducer = combineReducers({
  auth: authReducer,
  content: contentReducer,
   project: projectReducer,
});

export default adminReducer;
